import { render, staticRenderFns } from "./OnboardingStepInviteUser.vue?vue&type=template&id=6b46d214&scoped=true&"
import script from "./OnboardingStepInviteUser.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepInviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46d214",
  null
  
)

export default component.exports